import styled from 'helpers/styles';
import PropTypes from 'prop-types';
import ComponentStyles from 'styles/mixins/Component.styles';
import Box from 'components/atoms/Layout/Box/Box';
import utils from 'helpers/utils';

const StyledCards = styled(Box)
  .attrs((props) => {
    let attr = props;

    const sized = utils.isDefined(props.$columns) && utils.isDefined(props.$gap);
    const vars = {
      '--cards-columns': `${props.$columns}`,
      '--cards-gap': utils.isDefined(props.$gap) ? props.theme.layout(props.$gap) : null,
      '--cards-item-size': sized ? `calc(${100 / props.$columns}% - ${props.theme.layout(props.$columns > 1 ?
        (props.$gap * (props.$columns - 1)) / props.$columns : 0)})` : null
    };

    return utils.styleProps(attr, vars);
  })`
  &.Cards-grid {
    .Cards {
      &-cards {
        display: grid;
        gap: ${props => props.$css.$var('--cards-gap', false)};
      }
    }
    
    &.Cards-orientation-vertical {
      .Cards {
        &-cards {
          grid-template-columns: repeat(${props => props.$css.$var('--cards-columns', false)}, ${props => props.$css.$var('--cards-item-size', false)});
        }
      }
    }

    &.Cards-orientation-horizontal {
      .Cards {
        &-cards {
          grid-template-rows: repeat(${props => props.$css.$var('--cards-columns', false)}, ${props => props.$css.$var('--cards-item-size', false)});
        }
      }
    }
  }
  
  &.Cards-masonry {
    .Cards {
      &-cards {
        display: flex;
        align-content: flex-start;
        gap: ${props => props.$css.$var('--cards-gap', false)};
        overflow: hidden;
        
        &-section {
          &.masonry {
            display: flex;
            align-content: flex-start;
            gap: ${props => props.$css.$var('--cards-gap', false)};
            overflow: hidden;
          }
          
          &.grid {
            display: grid;
            gap: ${props => props.$css.$var('--cards-gap', false)};
          }
        }
      }
    }
    
    &.Cards-orientation-vertical {
      .Cards {
        &-cards {
          flex-direction: column;

          &-section {
            &.masonry {
              flex-flow: column wrap;

              .CardItem {
                scroll-margin-left: 0;
                scroll-margin-right: 0;
                width: ${props => props.$css.$var('--cards-item-size', false)};
              }
            }
            
            &.grid {
              grid-template-columns: repeat(${props => props.$css.$var('--cards-columns', false)}, ${props => props.$css.$var('--cards-item-size', false)});
            }
          }
        }
      }

      &.Cards-reverse {
        .Cards-cards {
          &-section {
            &.masonry {
              flex-flow: column wrap-reverse;
            }
          }
        }
      }
    }

    &.Cards-orientation-horizontal {
      .Cards {
        &-cards {
          flex-direction: row;

          &-section {
            &.masonry {
              flex-flow: row wrap;

              .CardItem {
                scroll-margin-top: 0;
                scroll-margin-bottom: 0;
                height: ${props => props.$css.$var('--cards-item-size', false)};
              }
            }
            
            &.grid {
              grid-template-rows: repeat(${props => props.$css.$var('--cards-columns', false)}, ${props => props.$css.$var('--cards-item-size', false)});
            }
          }
        }
      }

      &.Cards-reverse {
        .Cards-cards {
          &-section {
            &.masonry {
              flex-flow: row wrap-reverse;
            }
            &.grid {
              grid-template-rows: repeat(${props => props.$css.$var('--cards-columns', false)}, ${props => props.$css.$var('--cards-item-size', false)});
            }
          }
        }
      }
    }
  }

  &.Cards-flex {
    .Cards {
      &-cards {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        gap: ${props => props.$css.$var('--cards-gap', false)};
      }
    }
    
    &.Cards-orientation-vertical {
      &-cards {
        flex-direction: column;
      }
    }
  }
  
  ${ComponentStyles}
`;

StyledCards.propTypes = {
  theme: PropTypes.object
};

export default StyledCards;
